import React, { memo } from 'react';
import { bool, node, number, object, oneOfType, string } from 'prop-types';

import styles from './style';

const Actions = ({ children, className }) => (
  <div
    style={styles.modalSideActions}
    className={className}
    data-testid="divPopUpSideContent"
  >
    {children}
  </div>
);

const Content = (props) => {
  const { children, className, show, topColor, padding, height } = props;

  const containerStyle = { ...styles.modalSideContent };

  if (topColor) {
    containerStyle.borderTop = `solid ${topColor} 8px`;
  }
  if (padding) {
    containerStyle.padding = padding;
  }
  if (height) {
    containerStyle.height = height;
  }
  if (!show) {
    containerStyle.display = 'none';
  }

  return (
    <div
      style={containerStyle}
      className={className}
      data-testid="divPopUpSideContent"
    >
      {children}
    </div>
  );
};

const Container = (props) => {
  const { children, className, style } = props;

  return (
    <div
      style={{ ...styles.modalSideContainer, ...style }}
      className={className}
      data-testid="divPopUpSideContainer"
    >
      {children}
    </div>
  );
};

const PopUpSide = {
  Container: memo(Container),
  Content: memo(Content),
  Actions: memo(Actions)
};

Container.propTypes = {
  children: node.isRequired,
  className: string,
  style: object,
};

Container.defaultProps = {
  className: '',
  style: {},
};

Content.propTypes = {
  children: node.isRequired,
  className: string,
  height: oneOfType([string, number]),
  padding: oneOfType([string, number]),
  show: bool,
  topColor: string
};

Content.defaultProps = {
  className: '',
  height: '',
  padding: '',
  show: false,
  topColor: ''
};

Actions.propTypes = {
  children: node.isRequired,
  className: string
};

Actions.defaultProps = {
  className: ''
};

export default PopUpSide;
